/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Legacy form for probing a remote MCP server URL
 */
export type VerifyURLForm = {
  /**
   * The transport type for the remote MCP server (e.g. streamable-http)
   */
  transportType: string;
  /**
   * The URL of the remote MCP server to probe
   */
  url: string;
};

/** @internal */
export type VerifyURLForm$Outbound = {
  transport_type: string;
  url: string;
};

/** @internal */
export const VerifyURLForm$outboundSchema: z.ZodMiniType<
  VerifyURLForm$Outbound,
  VerifyURLForm
> = z.pipe(
  z.object({
    transportType: z.string(),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      transportType: "transport_type",
    });
  }),
);

export function verifyURLFormToJSON(verifyURLForm: VerifyURLForm): string {
  return JSON.stringify(VerifyURLForm$outboundSchema.parse(verifyURLForm));
}
